import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { AuthProvider } from './lib/auth'
import { queryClient } from './lib/query-client'
import { DialogProvider } from './components/dialogs'
import { WorkspaceNoticeBanner } from './components/workspace-notice-banner'
import './index.css'

const rootElement = document.getElementById('root')
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <DialogProvider>
            <RouterProvider router={router} />
            <WorkspaceNoticeBanner />
          </DialogProvider>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>
  )
}
